{
  "alert": "Melding",
  "dismiss": "Negeren"
}